import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class CreateAnExam extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Exam/Create");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}
class GetASingleExam extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Exam/GetBy");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetAllExams extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Exam/GetAll");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class UpdateAnExam extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Exam/Update");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetExamWithAnswers extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Exam/GetExamWithAnswers");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

export {
  CreateAnExam,
  GetASingleExam,
  GetAllExams,
  UpdateAnExam,
  GetExamWithAnswers,
};
